<template>
  <div class="detail">
    <div
      v-for="(item, index) in dataSource"
      :key="index"
      :class="['top-three', item.className]"
    >
      <CommonAvatar
        :size="item.displayRank * 1 === 1 ? 'large' : 'middle'"
        hasBorder
        hasCrown
        :crownNo="item.displayRank > 3 ? 3 : item.displayRank"
        :url="item.avatarUrl"
      />
      <RankList
        type="vertical"
        :list="item"
        @likeHandle="likeHandle"
        :todayMaxCancelNum="todayMaxCancelNum"
        :todayMaxNumByLike="todayMaxNumByLike"
        :myselfMaxNumByLike="myselfMaxNumByLike"
        :myselfInRankingInfo="myselfInRankingInfo"
      />
    </div>
  </div>
</template>
<script>
  import CommonAvatar from '../Avatar'
  import RankList from './index'

  export default {
    components: {
      CommonAvatar,
      RankList,
    },
    props: {
      datas: {
        type: Array,
        default: () => [],
      },
      todayMaxCancelNum: {
        type: Number,
        default: 0,
      },
      todayMaxNumByLike: {
        type: Number,
        default: 0,
      },
      myselfMaxNumByLike: {
        type: Number,
        default: 0,
      },
      myselfInRankingInfo: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      dataSource() {
        const clsNameMaps = {
          1: 'first',
          2: 'second',
          3: 'third',
        }
        const [firstItem = {}, secondItem = {}, thirdItem = {}] =
          this.datas || []
        return [secondItem, firstItem, thirdItem].map((item) => {
          item.className = clsNameMaps[item.displayRank]
          return item
        })
      },
    },
    methods: {
      likeHandle(list) {
        this.$emit('likeHandle', list)
      },
    },
  }
</script>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    .top-three.first {
      width: 228px !important;
      height: 349px !important;
    }
    .top-three.second,
    .top-three.third {
      width: 146px !important;
      height: 293px !important;
    }
  }
</style>
